import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  Image,
  ScrollView,
  StyleSheet,
  View,
  Text,
  TouchableWithoutFeedback,
} from './base_components';
import { useLocalState } from './local_state';
import LinkHighlight from './buttons/link_highlight';
import ImageButton from './buttons/image_button';
import OrgSelect from './org_select';

import MediaGrantStore from '../stores/media_grant_store';
import { useOrg, useUser } from '../stores/user_store';

import util from '../tools/util';

const styles = StyleSheet.create({
  leftNav: {
    paddingTop: '1rem',
    width: 0,
    alignSelf: 'stretch',
    backgroundColor: 'rgba(0,0,0,0.8)',
    '@media (min-width: 600px)': { width: '26rem' },
    '@media (max-width: 600px)': {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
    },
    overflow: 'hidden',
  },
  closed: { width: '0px !important' },
  open: { '@media (max-width: 600px)': { width: '100vw' } },
  scroller: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'column',
    backgroundColor: 'var(--sidebar-bg-color)',
    borderRightWidth: 1,
    borderRightColor: 'var(--sidebar-border-color)',
    '@media (max-width: 600px)': { right: '20vw' },
    scrollbarColor: 'var(--sidebar-scroll-color) var(--sidebar-bg-color)',
  },
  scrollerInner: {
    minHeight: '100%',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  minLogo: {
    marginLeft: '1rem',
    marginTop: '1rem',
    height: '4rem',
    flexDirection: 'row',
    alignSelf: 'stretch',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  minButton: {
    height: '2rem',
    width: '2rem',
    padding: '1rem',
    borderRadius: '0.5rem',
    filter: 'var(--icon-grey)',
  },
  logo: {
    marginLeft: '1rem',
    width: '10rem',
    height: '2.8rem',
    marginRight: '1rem',
    //filter: 'var(--icon-header-grey)',
  },
  orgView: {
    marginLeft: '1.5rem',
    marginRight: '1rem',
    marginTop: '1.7rem',
    marginBottom: '1rem',
    alignSelf: 'stretch',
    height: '4rem',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'var(--org-select-bg)',
    borderColor: 'var(--org-select-border)',
    borderWidth: 1,
    borderRadius: '1rem',
    boxShadow: '0px 4px 4px rgba(0,0,0,0.07)',
  },
  orgSelect: {
    marginRight: '0.5rem',
    flex: 1,
    alignSelf: 'stretch',
    color: 'var(--org-select-text)',
    fontSize: '1.4rem',
    fontWeight: 'bold',
  },
  listItem: {
    marginLeft: '1rem',
    marginRight: '1rem',
    marginTop: '0.4rem',
    marginBottom: '0.4rem',
    paddingRight: '1rem',
    paddingLeft: '1rem',
    alignSelf: 'stretch',
    height: '3.8rem',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderRadius: '0.5rem',
    overflow: 'hidden',
  },
  textView: {
    marginLeft: '1rem',
    flex: 1,
    flexDirection: 'column',
    overflow: 'hidden',
  },
  text: {
    display: 'block',
    //maxWidth: '100%',
    color: 'var(--sidebar-text-color)',
    fontSize: '1.4rem',
    fontWeight: 'normal',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  childText: { fontWeight: 'normal' },
  active: { backgroundColor: '#e2e2e2' },
  activeText: { fontWeight: '600' },
  icon: { width: '2rem', height: '2rem' },
  iconSpacer: { width: '2rem' },
  up: {
    marginRight: '0.6rem',
    width: '1.6rem',
    height: '1.6rem',
    transform: 'rotate(0deg)',
  },
  upClosed: { transform: 'rotate(180deg)' },
  middlePad: { flex: 1, minHeight: '2rem' },
  userView: {
    marginLeft: '1.5rem',
    marginRight: '1.5rem',
    marginTop: '1.7rem',
    marginBottom: '3rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    height: '5.6rem',
    alignSelf: 'stretch',
    backgroundColor: 'white',
    borderRadius: '1rem',
    borderWidth: 1,
    borderColor: 'var(--sidebar-account-border)',
    boxShadow: '0 4px 4px rgba(0,0,0,0.07)',
  },
  userInner: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  circle: {
    width: '3rem',
    height: '3rem',
    borderRadius: '3rem',
    backgroundColor: 'black',
    justifyContent: 'center',
    alignItems: 'center',
  },
  fakeIcon: { width: '2rem', height: '2rem', filter: 'var(--icon-white)' },
  nameEmail: {
    marginLeft: '1rem',
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  userName: {
    marginBottom: '0.3rem',
    display: 'block',
    color: 'var(--sidebar-username-color)',
    fontSize: '1.2rem',
    fontWeight: '600',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  email: {
    display: 'block',
    color: 'var(--sidebar-email-color)',
    fontSize: '1.2rem',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  verView: { position: 'absolute', bottom: 4, left: 4 },
  ver: { color: '#333', fontSize: 8 },
  device: {
    filter:
      'invert(48%) sepia(29%) saturate(724%) hue-rotate(254deg) brightness(91%) contrast(94%)',
  },
});
const UP = require('../assets/img/up_grey.svg');
const FOLDER = require('../assets/img/folder_color.svg');
const VOLUME = require('../assets/img/device_color.svg');
const DEVICE = require('../assets/img/monitor_black.svg');
const USERS = require('../assets/img/users_color.svg');
const ORG = require('../assets/img/org_color.svg');
const MIN = require('../assets/img/collapse_black.svg');
const LOGO = require('../assets/img/logo.png');
const ICON = require('../assets/img/maxlo_icon.svg');

type Props = {
  style?: any;
  open: boolean;
  closed: boolean;
  onClose: () => void;
  onClick: () => void;
};
export default function LeftNav(props: Props) {
  const { style, open, closed, onClose, onClick } = props;
  const org = useOrg();
  const user = useUser();
  const location = useLocation();
  const pathname = _decode(location?.pathname)?.toLowerCase?.();
  const grant_list = MediaGrantStore.useList(org?.org_id);
  React.useEffect(() => {
    if (org?.org_id) {
      MediaGrantStore.fetch(org?.org_id);
    }
  }, [org?.org_id]);

  const list = [
    {
      text: 'Home',
      url: '/home',
      extra: ['/download', '/upload', '/create_folder'],
      icon: FOLDER,
      children: [{ insert_grants: true }],
    },
    { text: 'Volumes', url: '/volume', icon: VOLUME, is_admin: true },
    {
      text: 'Devices',
      url: '/device',
      icon: DEVICE,
      icon_style: styles.device,
      have_devices: true,
    },
    { text: 'Users', url: '/admin/user', icon: USERS, is_admin: true },
    { text: 'Organization', url: `/org`, icon: ORG, is_admin: true },
  ];

  return org?.org_id ? (
    <View
      style={[
        styles.leftNav,
        closed ? styles.closed : null,
        open ? styles.open : null,
        style,
      ]}
    >
      <TouchableWithoutFeedback
        style={StyleSheet.absoluteFill}
        onPress={onClick}
      >
        <View style={StyleSheet.absoluteFill} />
      </TouchableWithoutFeedback>
      <ScrollView
        style={styles.scroller}
        contentContainerStyle={styles.scrollerInner}
      >
        <View style={styles.verView}>
          <Text style={styles.ver}>{process.env.VERSION}</Text>
        </View>
        <View style={styles.minLogo}>
          <ImageButton
            style={styles.minButton}
            underlayColor='rgba(0,0,0,0.05)'
            source={MIN}
            onPress={onClose}
          />
          <Image style={styles.logo} source={LOGO} />
        </View>
        <View style={styles.orgView}>
          <OrgSelect style={styles.orgSelect} />
        </View>
        {list.map((item, i) => {
          return (
            <ListEntry
              key={i}
              item={item}
              pathname={pathname}
              grantList={grant_list}
              onClick={onClick}
            />
          );
        })}
        <View style={styles.middlePad} />
        <LinkHighlight
          style={styles.userView}
          underlayColor='rgba(0,0,0,0.01)'
          url='/account'
          onPress={onClick}
        >
          <View style={styles.userInner}>
            <View style={styles.circle}>
              <Image style={styles.fakeIcon} source={ICON} />
            </View>
            <View style={styles.nameEmail}>
              {user?.user_name ? (
                <Text style={styles.userName}>{user.user_name}</Text>
              ) : null}
              <Text style={styles.email}>{user.email}</Text>
            </View>
          </View>
        </LinkHighlight>
      </ScrollView>
    </View>
  ) : null;
}
function ListEntry(props) {
  const { pathname, item, grantList, onClick } = props;
  const org = useOrg();
  let content: any = null;
  if (
    (!item.is_admin || org?.is_admin) &&
    (!item.have_devices || org?.cap_add_device || org?.device_count > 0)
  ) {
    const curr = grantList?.find?.(
      (g) =>
        pathname.startsWith(`/home/${g.grant_name}/`.toLowerCase()) ||
        pathname.startsWith(`/upload/${g.grant_name}/`.toLowerCase()) ||
        pathname.startsWith(`/create_folder/${g.grant_name}/`.toLowerCase()) ||
        pathname.startsWith(`/download/${g.grant_name}/`.toLowerCase())
    );
    const is_active = pathname.startsWith(item.url);
    const show_arrow = item?.children?.length > 0;

    let child_active: boolean = false;
    let list: any = [];
    item.children?.forEach?.((child) => {
      const { insert_grants } = child;
      if (insert_grants && grantList?.length > 0) {
        grantList.forEach((grant) => {
          const active = grant.media_grant_id === curr?.media_grant_id;
          child_active ||= active;
          list.push(
            <ListItem
              key={grant.media_grant_id}
              url={`/home/${grant.grant_name}/`}
              text={grant.grant_name}
              isActive={active}
              isChild={true}
              showArrow={false}
              onClick={onClick}
            />
          );
        });
      }
    });
    content = (
      <ListItem
        text={item.text}
        url={item.url}
        icon={item.icon}
        iconStyle={item.icon_style}
        showArrow={show_arrow && list.length > 0}
        isActive={is_active && !child_active}
        onClick={onClick}
      >
        {list}
      </ListItem>
    );
  }
  return content;
}
function ListItem(props) {
  const { text, icon, url, showArrow, isChild, isActive, onClick } = props;
  const [is_closed, setClosed] = useLocalState('close-' + url, false);

  function _onPress(e: any) {
    let ret;
    if (isActive && !isChild && props.children?.length > 0) {
      util.stopAll(e);
      const new_val = !is_closed;
      setClosed(new_val);
      ret = false;
    }
    onClick?.();
    return ret;
  }
  return (
    <>
      <LinkHighlight
        style={[styles.listItem, isActive ? styles.active : null]}
        underlayColor='rgba(0,0,0,0.05)'
        url={url}
        onPress={_onPress}
      >
        {icon ? (
          <Image style={[styles.icon, props.iconStyle]} source={icon} />
        ) : (
          <View style={styles.iconSpacer} />
        )}
        <View style={styles.textView}>
          <Text
            style={[
              styles.text,
              isChild ? styles.childText : null,
              isActive ? styles.activeText : null,
            ]}
            title={text}
          >
            {text}
          </Text>
        </View>
        {showArrow ? (
          <Image
            style={[styles.up, is_closed ? styles.upClosed : null]}
            source={UP}
          />
        ) : null}
      </LinkHighlight>
      {is_closed ? null : props.children}
    </>
  );
}
function _decode(pathname) {
  let ret = pathname;
  try {
    if (typeof pathname === 'string') {
      ret = decodeURI(pathname);
    }
  } catch {
    // ignore
  }
  return ret;
}
